import { defineComponent as d, openBlock as m, createBlock as f, unref as t, withCtx as i, createVNode as s, createTextVNode as r, toDisplayString as g } from "vue";
import z from "./ghl-ui.es224.js";
import "./ghl-ui.es22.js";
import "./ghl-ui.es313.js";
import c from "./ghl-ui.es314.js";
import u from "./ghl-ui.es68.js";
const S = d({
  name: "UIPagination",
  inheritAttrs: !1
}), y = d({
  ...S,
  props: {
    pageCount: {
      type: Number,
      default: 10
    },
    page: {
      type: Number
    },
    id: {
      type: String,
      required: !0
    },
    pageSize: {
      type: Number,
      default: void 0
    },
    pageSlot: {
      type: Number,
      default: 9
    },
    showSizePicker: {
      type: Boolean,
      default: !1
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 40]
    }
  },
  emits: ["update:page", "update:page-size"],
  setup(e, { emit: l }) {
    const p = l, n = z("Pagination");
    return (x, a) => (m(), f(t(c), {
      "page-size": e.pageSize,
      "page-sizes": e.pageSizes,
      "show-size-picker": e.showSizePicker,
      "page-count": e.pageCount,
      page: e.page,
      "page-slot": e.pageSlot,
      "onUpdate:page": a[0] || (a[0] = (o) => p("update:page", o)),
      "onUpdate:pageSize": a[1] || (a[1] = (o) => p("update:page-size", o))
    }, {
      prev: i(() => [
        s(t(u), {
          id: `${e.id}-previous`,
          size: "small"
        }, {
          default: i(() => [
            r(g(t(n).previous), 1)
          ]),
          _: 1
        }, 8, ["id"])
      ]),
      next: i(() => [
        s(t(u), {
          id: `${e.id}-next`,
          size: "small"
        }, {
          default: i(() => [
            r(g(t(n).next), 1)
          ]),
          _: 1
        }, 8, ["id"])
      ]),
      _: 1
    }, 8, ["page-size", "page-sizes", "show-size-picker", "page-count", "page", "page-slot"]));
  }
}), v = y;
export {
  v as default
};
